import { List,Record } from "immutable";

import createFromJS from "../../createFromJS";

export const StandardTypeRecord = Record({
  id: null,
  label: null,
  pluralLabel: null,
  hasDates: false,
  superTypes: List(),
  properties: List(),
  relationshipTypes: List(),
  isLocation: false
});

const data = {
  objects: {
    superTypes: "List",
    properties: "List",
    relationshipTypes: "List"
  }
};
createFromJS.registerCallback("StandardTypeRecord", createFromJS.createNestedCallback(StandardTypeRecord, data));
